import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6jbtamncqg: FaireBrandEntity = {
  token: "b_6jbtamncqg",
  type: "brand",
  name: "Miaoberry",
  avatarUrl:
    "https://cdn.faire.com/fastly/ab4e8907723b9d78d1e6c31d5e071ff49e55d8eee013795375b2137426370b4f.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/09c556012b64e1f73d817241b260af33ee3587738ab1b82ea916993fb07f7cb7.png",
  logoUrl:
    "https://cdn.faire.com/fastly/ab4e8907723b9d78d1e6c31d5e071ff49e55d8eee013795375b2137426370b4f.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/09c556012b64e1f73d817241b260af33ee3587738ab1b82ea916993fb07f7cb7.png",
  location: "West Chester, PA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 8,
  isInsider: true,
  description:
    'You guessed it, it was Meow~Berry!\n\nMiaoberry was born from a mother\'s love and a desire to cherish fleeting moments of childhood. Inspired by Amelia, whose first word after "mama" and "dada" was “meow” and whose favorite fruits were berries, Miaoberry creates baby essentials that are gentle, sustainable, and timeless.\n\n \n\nWith organic muslin at its heart, Miaoberry offers soft swaddles, blankets, and sleepwear designed for comfort, care, and lasting memories. Rooted in sustainability and thoughtful design, it’s a promise to nurture little ones while caring for the earth.\n\n \n\nWelcome to Miaoberry—where every baby is wrapped in love.',
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:41.338Z",
    importedBy: "entity-db-cli",
  },
};
